import useLocalStorage, { writeStorage } from '@rehooks/local-storage';
import * as R from 'ramda';
import React, { useLayoutEffect, useState } from 'react';
import { Redirect, useLocation } from 'react-router-dom';

const UTM_PARAMS = {
  source: 'utm_source',
  medium: 'utm_medium',
  campaign: 'utm_campaign',
  term: 'utm_term',
  content: 'utm_content',
};

export type UTMParams = Record<keyof typeof UTM_PARAMS, string | null>;

const LS_KEY = 'utmParams';

export function useUTMParams() {
  return R.pick(
    R.keys(UTM_PARAMS),
    useLocalStorage<UTMParams>(LS_KEY)[0] || {},
  );
}

function hasUTM(queryString: string) {
  // eslint-disable-next-line no-underscore-dangle
  return R.any(R.includes(R.__, queryString), R.values(UTM_PARAMS));
}

export default function UTMParamsProcessor() {
  const [, writeUTMParams] = useLocalStorage<UTMParams>(LS_KEY);
  const location = useLocation();
  const [processed, setProcessed] = useState(false);
  useLayoutEffect(
    () => {
      if (!processed && hasUTM(location.search)) {
        const query = new URLSearchParams(location.search);
        const utmParams = R.map((a) => query.get(a) || undefined, UTM_PARAMS as any);
        writeStorage(LS_KEY, (utmParams as any) as UTMParams);
        setProcessed(true);
      }
    },
    [location.search, processed, writeUTMParams],
  );
  return location.search && processed ? <Redirect to={location.pathname} /> : null;
}
